export const publicRoutes = {
  help: {
    index: '/help/help/index',
  },
  static: {
    contact: '/static/contact',
    terms_of_use: '/static/terms-of-use',
    privacy_policy: '/static/privacy-policy',
  },
  authentication: {
    login: '/auth/login',
    signup: '/auth/signup',
    confirm_otp: '/auth/confirm-otp',
    forgot_password: '/auth/forgot-password',
  },
};
